import { isAceleresIndividualOwn } from 'dashboard/constants/aceleresConnectionTypes';
import { isAceleresConversationStarted } from 'dashboard/helper/aceleresConversationState';

export const viewerOwnsPersonalInboxUnreadState = ({
  currentUserId,
  personalInboxAttributes = {},
  personalConversationOwnerId,
}) => {
  const normalizedCurrentUserId = Number(currentUserId);
  const personalInboxOwnerId = Number(
    personalInboxAttributes?.owner_chatwoot_user_id ||
      personalInboxAttributes?.ownerChatwootUserId ||
      0
  );
  const conversationOwnerId = Number(personalConversationOwnerId || 0);

  return (
    (isAceleresIndividualOwn(personalInboxAttributes?.connection_type) &&
      personalInboxOwnerId === normalizedCurrentUserId) ||
    (conversationOwnerId > 0 && conversationOwnerId === normalizedCurrentUserId)
  );
};

// Enquanto a conversa está em Novos (sem dono, ou atribuída mas ainda não
// iniciada — ver Aceleres::ConversationState no backend), abri-la não pode
// zerar o não-lido para ninguém, nem para o vendedor responsável. Só quando
// a conversa já foi iniciada é que o assignee é considerado dono do estado
// de leitura.
export const viewerOwnsUnreadState = ({
  currentUserId,
  assigneeId,
  isConversationStarted = true,
  preserveAssignedUnread = false,
  personalInboxAttributes = {},
  personalConversationOwnerId,
}) => {
  return (
    preserveAssignedUnread ||
    (isConversationStarted &&
      !!assigneeId &&
      Number(assigneeId) === Number(currentUserId)) ||
    viewerOwnsPersonalInboxUnreadState({
      currentUserId,
      personalInboxAttributes,
      personalConversationOwnerId,
    })
  );
};

// Pessoais are owned by the personal connection, not necessarily by the
// assignee field. Keep the unread state visible to the owner of that box.
export const shouldPreserveAssignedUnreadForBox = box =>
  ['outros', 'pessoais'].includes(String(box || ''));

export const sanitizeConversationUnreadForViewer = (
  conversation,
  currentUserId,
  { preserveAssignedUnread = false } = {}
) => {
  if (!conversation) {
    return conversation;
  }

  const assigneeId =
    conversation?.meta?.assignee?.id ??
    conversation?.assignee_id ??
    conversation?.conversation?.assignee_id;

  if (
    viewerOwnsUnreadState({
      currentUserId,
      assigneeId,
      isConversationStarted: isAceleresConversationStarted(
        conversation?.conversation || conversation
      ),
      preserveAssignedUnread,
    })
  ) {
    return conversation;
  }

  return {
    ...conversation,
    unread_count: 0,
  };
};

export const sanitizeConversationListUnreadForViewer = (
  conversations,
  currentUserId,
  options = {}
) => {
  if (!Array.isArray(conversations)) {
    return [];
  }

  return conversations.map(conversation =>
    sanitizeConversationUnreadForViewer(conversation, currentUserId, options)
  );
};

export const sanitizeMessageConversationUnreadForViewer = (
  message,
  currentUserId,
  options = {}
) => {
  if (!message?.conversation) {
    return message;
  }

  return {
    ...message,
    conversation: sanitizeConversationUnreadForViewer(
      message.conversation,
      currentUserId,
      options
    ),
  };
};
